
import {
    CLOSE_NOTIFICATION,
    LOGIN_REQUEST_FAILED,
    LOGIN_REQUEST_STARTED,
    LOGIN_REQUEST_SUCCESS,
    LOGOUT_USER
} from "./AuthConstants";

export const loginRequestStarted = () => {
    return {
        type: LOGIN_REQUEST_STARTED
    }
}

export const loginRequestSuccess = (user) => {
    return {
        type: LOGIN_REQUEST_SUCCESS,
        payload:user
    }
}

export const loginRequestFailed = (error) => {
    return {
        type: LOGIN_REQUEST_FAILED,
        payload:error
    }
}

export const closeNotification = () => {
    return {
        type: CLOSE_NOTIFICATION
    }
}

export const logoutUser = () =>{
    return {
        type:LOGOUT_USER
    }
}

